import React from 'react';
import PropTypes from 'prop-types';

const TableRow = (props) => {
  const { children, header, action, className, style, border = 'full-border', isHover } = props;

  return (
    <tr
      onMouseOver={isHover}
      style={style}
      onClick={action}
      className={header ? `table-row-header ${className} ${border}` : `table-row ${className} ${border}`}
    >
      {children}
    </tr>
  );
};

TableRow.propTypes = {
  header: PropTypes.bool,
  isHover: PropTypes.func,
};

export default TableRow;
